import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import { CloseIcon, Box as DarkBox, IconButton } from '@hivewatch/dark'

import { headerRowStyles, titleStyles } from './DarkTourPlansPanel.styles'

interface DarkTourPlanFormHeaderIProps {
  onClose: () => void
  edit?: boolean
}

export const DarkTourPlanFormHeader = ({
  onClose,
  edit,
}: DarkTourPlanFormHeaderIProps) => {
  const colorScheme = useLightMode()
  const { t } = useTranslation()

  return (
    <DarkBox {...headerRowStyles} justifyContent='space-between'>
      <DarkBox {...titleStyles(colorScheme)}>
        {edit
          ? t('floors:plan_edit_tour_title')
          : t('floors:plan_create_tour_title')}
      </DarkBox>
      {/* Same close affordance as the incident drawer header (ENG-32001). */}
      <IconButton
        _active={{ bg: 'transparent' }}
        aria-label={t('common:close')}
        colorScheme={colorScheme}
        data-testid='tourplan_form_closeButton'
        dimension={36}
        hoverBgColor='transparent'
        icon={<CloseIcon size={11} />}
        onClick={onClose}
      />
    </DarkBox>
  )
}
